/* @vite-ignore */
import React from 'react';
import DefaultLayout from '@/layouts/DefaultLayout';
import { lazyLoadRoutes } from './lazyLoadRoutes';
import { RouteObject } from 'react-router';
import ProtectedRoute from '@/utils/ProtectedRoute';

const initialRoutes: RouteObject = {
  path: '/',
  element: React.createElement(DefaultLayout),
  children: [
    {
      path: '/',
      element: lazyLoadRoutes('HomePage'),
    },
    {
      path: '/products',
      element: lazyLoadRoutes('Product'),
    },
    {
      path: '/products/:id',
      element: lazyLoadRoutes('ProductDetail'),
    },
    {
      path: '/application',
      element: lazyLoadRoutes('Application'),
    },
    {
      path: '/software',
      element: lazyLoadRoutes('Software'),
    },
    {
      path: '/mission_vision',
      element: lazyLoadRoutes('MissionVision'),
    },
    {
      path: '/team',
      element: lazyLoadRoutes('Team'),
    },
    {
      path: '/partnership',
      element: lazyLoadRoutes('Partnership'),
    },
    {
      path: '/advisors',
      element: lazyLoadRoutes('Advisors'),
    },
    {
      path: '/publications',
      element: lazyLoadRoutes('Publications'),
    },
    {
      path: '/events',
      element: lazyLoadRoutes('Events'),
    },
    {
      path: '/careers',
      element: lazyLoadRoutes('Careers'),
    },
    {
      path: '/contact_us',
      element: lazyLoadRoutes('ContactUs'),
    },
    {
      path: '/cart',
      element: lazyLoadRoutes('Cart'),
    },
    {
      path: '/login',
      element: React.createElement(ProtectedRoute, {
        redirectTo: '/',
        requireAuth: false,
        children: lazyLoadRoutes('Profile'),
      }),
    },
    {
      path: '/forgot-password',
      element: React.createElement(ProtectedRoute, {
        redirectTo: '/',
        requireAuth: false,
        children: lazyLoadRoutes('PasswordResetRequest'),
      }),
    },
    {
      path: '/reset-password',
      element: React.createElement(ProtectedRoute, {
        redirectTo: '/',
        requireAuth: false,
        children: lazyLoadRoutes('PasswordResetConfirm'),
      }),
    },
    {
      path: '/privacy_policy',
      element: lazyLoadRoutes('PolicyPrivacy'),
    },
    {
      path: '/terms_conditions',
      element: lazyLoadRoutes('Terms'),
    },
    {
      path: '*',
      element: lazyLoadRoutes('NoScreenPage'),
    },
  ],
};

export default initialRoutes;
